import linkedInIcon from 'src/images/icons/social/linkedin@21x24.svg'
import instagramIcon from 'src/images/icons/social/instagram@21x24.svg'
import twitterIcon from 'src/images/icons/social/twitter@24x24.svg'

export const solutions = [
  {
    to: '/case-studies',
    text: 'Case Studies',
  },
  {
    to: '/resellers',
    text: 'Resellers',
  },
  {
    to: '/drivers',
    text: 'Drivers',
  },

  {
    to: '/calculator',
    text: 'ROI Calculator',
  },
]

export const company = [
  {
    to: '/about-us',
    text: 'About Us',
  },
  {
    to: '/press',
    text: 'Press',
  },
  {
    to: '/careers',
    text: 'Careers',
  },
  {
    to: '/security',
    text: 'Security',
  },
  {
    to: '/privacy-policy',
    text: 'Privacy Policy',
  },
  {
    to: '/responsible-disclosures',
    text: 'Responsible Disclosure',
  },
  {
    to: '/driver-terms-of-service/',
    text: 'Driver Terms',
  },
]

export const login = [
  {
    text: 'Building Manager Login',
    href: 'https://desktop.xealenergy.com/',
  },
  {
    text: 'Partner Login',
    href: 'https://xealenergy.my.site.com/PRM',
  },
]

export const socials = {
  linkedIn: {
    icon: linkedInIcon,
    href: 'https://www.linkedin.com/company/xealenergy/',
  },
  instagram: {
    icon: instagramIcon,
    href: 'https://www.instagram.com/xealenergy/',
  },
  twitter: {
    icon: twitterIcon,
    href: 'https://x.com/xealenergy',
  },
}
export const salesAndSupport = {
  phone: {
    text: '(800) 484-4515',
    href: 'tel:(800)484-4515',
  },
  email: {
    text: 'info@xealenergy.com',
    href: 'mailto:info@xealenergy.com',
  },
}
